module.exports = __webpack_public_path__ + "img/PXL_20230525_110621355.6d0a6543.jpg";